import '~/js/modules/stickyNav';
import '~/js/modules/resort-home/slider-main';
import '~/js/modules/resort-home/inclusions';
import '~/js/modules/resort-home/rooms-and-suites-slider';

import '~/js/sections/root/includes/slider-countdown';
import '~/js/modules/countdown';

import 'slick-carousel';

// import QuickQuote from '~/js/components/global/QuickQuote';

// const quickQuoteNode = document.getElementsByClassName('resort-qq');
const { rstCode = '' } = window.beaches_app.page;

// for (const qqRootNode of quickQuoteNode) {
//   ReactDOM.render(
//     <QuickQuote
//       schedulerModeIndex={ 4 }
//       hasCountries={ false }
//       hasResorts={ false }
//       brand="beaches"
//       noLabels
//       defaultResortCode={ rstCode }
//       quoteButtonText="CHECK RATES <i class='icon-link-arrow-beaches'></i>"
//       occupancyLabels={false}
//       startDatePlaceholderText="Check In"
//       endDatePlaceholderText="Check Out"
//       adultsDropdownPlaceHolder="<span class='occupancy-placeholder'>Adults<span class='display-block'>(Age 16+)</span></span>"
//       childrenDropdownPlaceHolder="<span class='occupancy-placeholder'>Kids<span class='display-block'>(Age 0-15)</span></span>"
//     />,
//     qqRootNode
//   );
// }

// Variable Declaration
const $carousel = $('#resorts-carousel');
const $control = $('.resort-carousel-control');

// Initialization carousel
$carousel.slick({
  infinite: false,
  appendArrows: $control,
  mobileFirst: true,
  variableWidth: true,
  arrows: false,
  prevArrow: '<button class="arrow arrow-prev1"></button>',
  nextArrow: '<button class="arrow arrow-next"></button>',
  responsive: [{
    breakpoint: 1024,
    settings: {
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
    }
  }]
});
